import { forEach, trim } from 'lodash';
import sanitizeHtml from 'sanitize-html';
import { ChatActivityReason } from 'requests/resources';

const URLify = (s: string) => {
  let result = s;
  const urls = result.match(/( |^)((((ftp|https?):\/\/)|(w{3}\.))[-\w@:%_+.~#?,&//=]+)/gm);
  if (urls) {
    forEach(urls, (urlWithSpace) => {
      let url = urlWithSpace;
      let prefix = '';
      if (urlWithSpace.indexOf(' ') === 0) {
        url = trim(urlWithSpace);
        prefix = ' ';
      }
      result = result.replace(urlWithSpace, `${prefix}<a target="_blank" href="${url}">${url}</a>`);
    });
  }
  return result.replace('(', '<br/>(');
};

export const parseMessageContent = (messageHtml: string, disableLinks: boolean) => {
  let result = messageHtml;
  if (disableLinks) {
    result = sanitizeHtml(result, {
      transformTags: {
        a: 'span',
      },
    });
  } else {
    result = URLify(messageHtml);
  }
  return result;
};

export const replaceChatActivityReasonKeys = (text: string, chatActivityReasons?: ChatActivityReason[]) => {
  let result = text;
  forEach(chatActivityReasons, (reason) => {
    result = result.replace(`Reason: ${reason._id}`, `Reason: ${reason.text.original}`);
  });

  forEach(
    [
      {
        _id: 'no-further-action',
        text: 'No further action needed',
      },
      {
        _id: 'not-relevant',
        text: 'This isn’t relevant to the patient’s care',
      },
      {
        _id: 'spam',
        text: 'This is spam',
      },
      {
        _id: 'offensive',
        text: 'This message is offensive',
      },
      {
        _id: 'not-actionable',
        text: 'This isn’t actionable',
      },
      {
        _id: 'other',
        text: 'Other',
      },
    ],
    (reason) => {
      result = result.replace(`Reason: ${reason._id}`, `Reason: ${reason.text}`);
    },
  );
  return result;
};
